// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.linearView_HzAju {
  position : absolute;
  top : 0;
  left : 0;
  bottom : 0;
  right : 0;
  overflow-x: hidden;
  overflow-y: hidden;
  display : flex;
  flex-direction: column;
}

.header_nC5PV {
  position:relative;
  overflow:hidden;
  flex-shrink: 0
}

.content_Bqpjm {
  position: relative;
  overflow : auto;
  flex-grow : 1;
  flex-shrink : 1;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-linear-view-elements/lib/LinearView.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,eAAe;AACjB","sourcesContent":[".linearView {\n  position : absolute;\n  top : 0;\n  left : 0;\n  bottom : 0;\n  right : 0;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  display : flex;\n  flex-direction: column;\n}\n\n.header {\n  position:relative;\n  overflow:hidden;\n  flex-shrink: 0\n}\n\n.content {\n  position: relative;\n  overflow : auto;\n  flex-grow : 1;\n  flex-shrink : 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linearView": `linearView_HzAju`,
	"header": `header_nC5PV`,
	"content": `content_Bqpjm`
};
export default ___CSS_LOADER_EXPORT___;
